export default "<p>configuracion-inicial works!</p>\r\n";